import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {L10nModule} from '../translate/l10n.module';
import {FlashMessageOfDirective} from './flash-message-of.directive';
import {FlashMessageComponent} from './flash-message.component';
import {FlashMessagesAnchorComponent} from './flash-messages-anchor.component';
import {FlashMessagesService} from './flash-messages.service';

@NgModule({
    imports: [
        CommonModule,
        L10nModule
    ],
    declarations: [
        FlashMessagesAnchorComponent,
        FlashMessageComponent,
        FlashMessageOfDirective
    ],
    exports: [
        FlashMessagesAnchorComponent,
        FlashMessageOfDirective
    ],
    providers: [
        FlashMessagesService
    ]
})
export class FlashMessageModule {}
